// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";

import "./controllers";
// Paired with local_time gem
import LocalTime from "local-time";
LocalTime.start();

function errorReportingEnabled() {
  return document.querySelector('meta[name="error-reporting"]')?.content === "enabled";
}

function normalizeError(error) {
  if (error instanceof Error) {
    return { name: error.name, message: error.message, stack: error.stack || "" };
  }

  return { name: "Error", message: String(error), stack: "" };
}

function reportClientError(error, extra = {}) {
  if (!errorReportingEnabled()) return;

  const { name, message, stack } = normalizeError(error);
  if (!message) return;

  fetch("/client-errors", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      name,
      message,
      stack,
      url: window.location.href,
      identifier: extra.identifier || "",
    }),
    keepalive: true,
  }).catch(() => {});
}

window.addEventListener("error", (event) => {
  reportClientError(event.error || event.message);
});

window.addEventListener("unhandledrejection", (event) => {
  reportClientError(event.reason);
});

if (window.Stimulus) {
  window.Stimulus.handleError = (error, message, detail) => {
    console.error(`${message}\n\n`, error, detail);
    reportClientError(error, { identifier: detail.identifier || message });
  };
}
